import React from "react";
import useTitle from "../../hooks/UseTittle";

import { motion } from "framer-motion";

const Contact = () => {
  useTitle("Mofazzel | Contact");

  const parentVariant = {
    hidden: {
      opacity: 0,
      x: 200,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.8,
        ease: [0, 0.71, 0.2, 1.01],
      },
    },
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        damping: 100,
      },
    },
  };

  return (
    <>
      <motion.div
        variants={parentVariant}
        initial="hidden"
        animate="visible"
        id="contact"
        className="bg-b-drop pb-1"
      >
        <h2 className=" after-effect after:left-60 after:top-[76px] my-12 md:mb-[30px] pl-4 md:pl-[60px]">
          Contact
        </h2>

        <div className="mx-4 md:mx-[60px] px-2 rounded-xl mb-[30px] md:mb-[60px]">
          <h3 className="text-4xl mb-10">
            <span className="text-gray-lite">
              I'm always open to discussing
            </span>
            <br />
            <span className="font-semibold ">Web Development work.</span>
          </h3>

          <form action="#" method="POST">
            <div data-success="Your message has been received, We will contact you soon."></div>
            <div className="empty_notice">
              <span>Please Fill Required Fields</span>
            </div>

            {/* <!-- name input  --> */}
            <div className="relative z-0 w-full mt-[40px] mb-8 group">
              <input
                type="text"
                id="name"
                name="name"
                className="block autofill:bg-transparent py-2.5 px-0 w-full text-sm text-gray-lite bg-transparent border-0 border-b-[2px] border-[#B5B5B5] appearance-none  darkk:border-[#333333] darkk:focus:border-[#FF6464] focus:outline-none focus:ring-0 focus:border-[#FF6464] peer"
                placeholder=" "
                required=""
              />
              <label
                for="name"
                className="peer-focus:font-medium absolute text-sm text-gray-500 darkk:text-color-910 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#FF6464] peer-focus:darkk:text-[#FF6464] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                Name *{" "}
              </label>
            </div>

            {/* <!-- email input  --> */}
            <div className="relative z-0 w-full mb-8 group">
              <input
                type="email"
                name="email"
                className="block autofill:text-red-900 needed py-2.5 px-0 w-full text-sm text-gray-lite bg-transparent border-0 border-b-[2px] border-[#B5B5B5] appearance-none  darkk:border-[#333333] darkk:focus:border-[#FF6464] focus:outline-none focus:ring-0 focus:border-[#5185D4] peer"
                placeholder=" "
                id="email"
                required=""
              />
              <label
                for="email"
                className="peer-focus:font-medium absolute text-sm text-gray-500 darkk:text-color-910 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#5185D4] peer-focus:darkk:text-[#FF6464] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                Email *{" "}
              </label>
            </div>

            {/* <!-- message input  --> */}
            <div className="relative z-0 w-full mb-8 group">
              <input
                type="text"
                name="message"
                className="block py-2.5 px-0 w-full text-sm text-gray-lite bg-transparent border-0 border-b-[2px] border-[#B5B5B5] appearance-none  darkk:border-[#333333] darkk:focus:border-[#FF6464] focus:outline-none focus:ring-0 focus:border-[#CA56F2] peer"
                placeholder=" "
                id="message"
                required=""
              />
              <label
                for="message"
                className="peer-focus:font-medium absolute text-sm text-gray-500 darkk:text-color-910 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#CA56F2] peer-focus:darkk:text-[#FF6464] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                Message *{" "}
              </label>
            </div>

            {/* <!-- submit buttons --> */}
            <input
              type="submit"
              className="px-6 py-2 rounded-lg border-[2px] mt-3 border-color-910 font-semibold cursor-pointer hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white transition-colors duration-300 ease-in-out hover:border-transparent "
              value="Submit"
            />
          </form>
        </div>
      </motion.div>
    </>
  );
};

export default Contact;
